class ProductDescription extends HTMLElement {
  connectedCallback() {
    const text = this.querySelector('[data-description-text]');
    const toggle = this.querySelector('[data-description-toggle]');
    if (!text || !toggle) return;

    // Hide the "show more" trigger when the description is not actually clamped.
    requestAnimationFrame(() => {
      const isTruncated = text.scrollHeight > text.clientHeight;
      toggle.hidden = !isTruncated;
    });
  }
}

customElements.define('product-description', ProductDescription);
